import React from 'react';
import SearchField from '../components/SearchField';

export const ArticleFilter = (props) => {

    const handleQueryChange = (query) => {
        props.updateQuery(query);
    };

    return (
            <div className="row">
                <div className="col-3">
                    <label>&nbsp;</label>
                    <SearchField className="mb-2 mr-sm-2 mb-sm-0" value={props.query} onCommit={handleQueryChange}/>
                </div>
            </div>
    )
};

export default ArticleFilter;


// WEBPACK FOOTER //
// ./src/admin/article/ArticleFilter.js